import { Channel, ChannelType } from '@/types/channel.types';

export function isTownhallChannel(value: Channel['type']): boolean {
  return value === ChannelType.BrandTV;
}

export function isWebinarChannel(value: Channel['type']): boolean {
  return value === ChannelType.Webinar;
}
